import React from "react";
import Group from "../../components/Group/Group";
import {useSelector} from "react-redux";
import styles from "./GroupsContainer.module.scss";
import FacetsContainer from "../FacetsContainer/FacetsContainer";

const GroupsContainer = (props) => {
    const newFilterState = useSelector(state => state.newFilterReducer);
    const activeGroup = newFilterState.activeGroup;
    const isMobile = newFilterState.isMobile;
    const availableGroups = {...newFilterState.availableGroups};

    let groupsR = [];

    // UTDTEK-706: The order should be: fagretning, fagomrade, fylke(omrade), niva, and then all the others.
    const weights = { // Note: They need to have a distance of at least 2, so that their children can get the right lower on mobile!
        fagretning: -12,
        fagomrade: -10,
        utdanningsprogram: -8,
        omrade: -6,
        niva: -4,
    };

    let isOneResult = Object.entries(availableGroups).length === 1 ? true : false;  // Used to set a group to active by default if only 1 group.
    for (const [key, item] of Object.entries(availableGroups)) {

        // Initialize as "false" to show it by default. Will be converted to integer and summed up right below, to hide
        // it if the count is zero. @See UTDTEK-1841
        let myChildrenTotalCount = false;
        if (item.children !== undefined) {
            myChildrenTotalCount = 0;
            for (const [childKey, childItem] of Object.entries(item.children)) {
                const childItemCount = childItem.count;
                myChildrenTotalCount += childItemCount;
            }
        }

        if (myChildrenTotalCount === false || myChildrenTotalCount > 0) {
            groupsR.push(<Group
                key={key}
                id={key}
                value={item.value}
                facetName={item.facetName}
                middlefacetGroupID={item.middlefacetGroupID !== undefined ? item.middlefacetGroupID : null}
                middlefacetID={item.middlefacetID !== undefined ? item.middlefacetID : null}
                middlefacetValue={item.middlefacetValue !== undefined ? item.middlefacetValue : null}
                weight={weights[key] !== undefined ? weights[key] : null}
                defaultActive={isOneResult}
                childrenTotalCount={myChildrenTotalCount}
            />);
        }

        // On desktop the menu has 2 columns: The groups are on the left the facets on the right.
        // On mobile the facets are expected to be rendered right below the group they belong to.
        if (activeGroup && isMobile && (key === activeGroup)) {
            groupsR.push(<FacetsContainer
                key={key + '-facets'}
                weight={weights[key] !== undefined ? (weights[key] + 1) : null}
            />);
        }

    }

    return (
        <div className={styles.wrapper}>
            {groupsR}
        </div>
    );
};

export default GroupsContainer;
